import React from 'react';
import './Select.scss';
export interface Props {
  selectClass?: any;
  selectId?: any;
  selectValue?: any;
  children?: any;
  onChange?: (event: any) => void;
}
const Select = ({
  selectClass,
  selectId,
  selectValue,
  children,
  onChange
}:Props) => {
  return (
    <select className={`mfg-select${selectClass?(' ' + selectClass) :''}`} id={selectId} value={selectValue} onChange={onChange}>
      {children}
    </select>
  )
}

export default Select